import { useState, useEffect } from "react";
import { Box, Button, TextField, CardMedia, Card } from "@mui/material";
import Detail from "../../../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseFooterLists } from "./UseFooterLists";
import { useNavigate, useLocation } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import useBreakpoints from "../../../../hooks/useBreakpoints";

export default function AddListItem(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { SetFooterListItems, validateListItems } = UseFooterLists();
  const [state, setState] = useState({
    id: undefined,
    FooterListID: undefined,
    title: undefined,
    url: undefined,
  });
  const { isSmall } = useBreakpoints();

  const [errorState, setErrorState] = useState({
    title: false,
  });

  const [imgState, setImgState] = useState({
    imageFile: undefined,
    imageUrl: undefined,
  });

  const handleChangeImage = (file) => {
    setImgState({
      imageFile: file[0],
      imageUrl: URL.createObjectURL(file[0]),
    });
  };

  useEffect(() => {
    if (location.state && location.state.listId) {
      setState({ ...state, FooterListID: location.state.listId });
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/footerManage/editList",
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/homepagemanage" },
          {
            name: "مدیریت فوتر",
            url: "/footerManage",
          },
          {
            name: "ویرایش لیست",
            url: "/footerManage/editList",
            listId: location.state && location.state.listId,
            model: location.state && location.state.model,
          },
          {
            name: "افزودن آیتم",
            url: "/footerManage/editList/addItem",
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            fullWidth
            value={state.title ? state.title : ""}
            label="عنوان"
            size="small"
            variant="outlined"
            error={errorState.title}
            onChange={(evt) => {
              setState({ ...state, title: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 8"}>
          <TextField
            fullWidth
            value={state.url ? state.url : ""}
            label="لینک"
            sx={{
              textarea: { direction: "rtl" },
            }}
            multiline
            maxRows={4}
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, url: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 4"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 2"}>
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "100px", height: "auto" }}>
                <Card
                  sx={{
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                    // bgcolor: "#d3d3d3",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.imageUrl
                        ? imgState.imageUrl
                        : "/static/img/no-photos.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
        </Box>
        {!isSmall && <Box gridColumn="span 10"></Box>}
        <Box
          gridColumn={isSmall ? "span 12" : "span 3"}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => {
              if (validateListItems(state, setErrorState) == 200) {
                setProgress(true);
                SetFooterListItems(state, imgState.imageFile, (calback) => {
                  navigate("/footerManage/editList", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
